import React from "react";
import OrderList from "./OrderList";
import AddUpdateOrderPage from "./AddUpdateOrderPage";
import { ICustomerPageState } from "../../../interfaces/Index";
import { IOrderPageProps } from "../../../interfaces/order.interface";
import HeadingText from "../../common/HeadingText/HeadingText";

export default class OrderPage extends React.Component<
  IOrderPageProps,
  ICustomerPageState
> {
  constructor(props: IOrderPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedOrder: null,
      isOrderAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
    };
  }

  renderAddUpdateOrderPage = () => {
    const { isEdit, selectedOrder } = this.state;
    const {
      isLoading,
      isError,
      error,
      createOrder,
      history,
      location,
      match,
      isOrderCreated,
      orderDetails,
      isOrderDetailsFetched,
      getOrderDetails,
      clearOrderDetails,
      isOrderUpdated,
      updateOrder,
      updateOrderStatus,
      isOrderStatusUpdated,
      getBulkCustomerDetailsByIdAction,
      bulkCustomerDetails,
      clearBulkCustomerDetailsNewAction,
      getPromosForOrder,
      getOrderPriceBreakdown,
      isPromosForOrderFetched,
      orderPriceBreakdown,
      isOrderPriceBreakdownFetched,
      promosForOrder,
      fetchCreditPaymentPlans,
      fetchUserCreditLimit,
      userCreditPlan,
      creditPaymentPlans,
      clearCreditLimitAndPlansAction,
      fetchCreditUser,
      userCreditStatus,
    } = this.props;
    return (
      <AddUpdateOrderPage
        order={selectedOrder}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        updateOrder={updateOrder}
        createOrder={createOrder}
        fetchCreditUser={fetchCreditUser}
        isOrderCreated={isOrderCreated}
        history={history}
        location={location}
        match={match}
        orderDetails={orderDetails}
        isOrderDetailsFetched={isOrderDetailsFetched}
        getOrderDetails={getOrderDetails}
        clearOrderDetails={clearOrderDetails}
        isOrderUpdated={isOrderUpdated}
        updateOrderStatus={updateOrderStatus}
        isOrderStatusUpdated={isOrderStatusUpdated}
        getBulkCustomerDetailsByIdAction={getBulkCustomerDetailsByIdAction}
        bulkCustomerDetails={bulkCustomerDetails}
        clearBulkCustomerDetailsNewAction={clearBulkCustomerDetailsNewAction}
        getPromosForOrder={getPromosForOrder}
        getOrderPriceBreakdown={getOrderPriceBreakdown}
        orderPriceBreakdown={orderPriceBreakdown}
        isOrderPriceBreakdownFetched={isOrderPriceBreakdownFetched}
        isPromosForOrderFetched={isPromosForOrderFetched}
        promosForOrder={promosForOrder}
        fetchCreditPaymentPlans={fetchCreditPaymentPlans}
        fetchUserCreditLimit={fetchUserCreditLimit}
        clearCreditLimitAndPlansAction={clearCreditLimitAndPlansAction}
        userCreditPlan={userCreditPlan}
        creditPaymentPlans={creditPaymentPlans}
        userCreditStatus={userCreditStatus}
      />
    );
  };

  renderOrderListing = () => {
    const {
      orders,
      isFetchOrderLoading,
      isFetchOrderError,
      error,
      pagination,
      isOrderCreated,
      isOrderUpdated,
      fetchOrders,
      isOrderStatusUpdated,
    } = this.props;
    const { isOrderAddUpdate, searchText, currentListPosition } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Orders" isMainHeading={true} />
        </section>
        <OrderList
          fetchOrders={fetchOrders}
          orders={orders}
          pagination={pagination}
          isLoading={isFetchOrderLoading}
          isError={isFetchOrderError}
          error={error}
          isOrderAddedorUpdated={isOrderAddUpdate}
          isOrderCreated={isOrderCreated}
          isOrderUpdated={isOrderUpdated}
          addUpdatePageHandler={this.toggleAddUpdateOrderPage}
          isOrderStatusUpdated={isOrderStatusUpdated}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
        />
      </>
    );
  };

  toggleAddUpdateOrderPage = (
    isEdit: boolean = false,
    selectedOrder: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedOrder: selectedOrder,
      searchText: searchText,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isOrderAddUpdate: isAddUpdate,
      searchText: searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateOrderPage()
          : this.renderOrderListing()}
      </div>
    );
  }
}
